export enum AdrTypes {
    CONTAINER = "container",
    DRIVER = "driver",
    TANKER = "tanker",
    CHASSIS = "chassis",
    TRACTOR = "tractor"
}